import React from "react";
import { Card } from "reactstrap";
import { Button, Tag } from "antd";

export class VisitCard extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div>
        {this.props.visitsList.map((visit, idx) => (
          <Card
            key={idx}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
              marginBottom: "14px",
            }}
          >
            <div
              style={{
                minWidth: "200px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 4,
              }}
            >
              <h6 style={{ margin: 0 }}>{visit.title}</h6>
              <div style={{ display: "flex", gap: 8 }}>
                <Tag color={visit.visit_status.statusColor}>
                  {visit.visit_status.name}
                </Tag>
                {visit.finish_reason && (
                  <Tag color={visit.finish_reason.finishColor}>
                    {visit.finish_reason.name}
                  </Tag>
                )}
              </div>
            </div>

            <div
              style={{
                minWidth: "150px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 4,
              }}
            >
              <div>
                {visit.technician.length === 0 ? (
                  <Tag bordered={false} color="red" key={77}>
                    Sin técnico asignado
                  </Tag>
                ) : (
                  visit.technician.map((technician, idx) => (
                    <Tag bordered={false} color="purple" key={idx}>
                      {technician.username}
                    </Tag>
                  ))
                )}
              </div>
              <Button
                type="link"
                onClick={() => this.props.handleOpenMarker(idx)}
              >
                Ver Visita
              </Button>
            </div>
          </Card>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/HomeVisits/components/VisitCard.jsx